import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { useDispatch } from "react-redux";
import {
  useLazyTransactionReportQuery,
  useLazyOwnerPaymentReportQuery,
  useLazyBookingDetailsReportQuery,
  useOwnerPaymentImportMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";

const ReportPage = () => {
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);
  const [tab, setTab] = useState(1);
  const [category, setcategory] = useState("");
  const [booking_details, setbooking_details] = useState([]);
  const [owner_details, setowner_details] = useState([]);
  const [transaction_details, settransaction_details] = useState([]);
  const [from_date, setfrom_date] = useState("");
  const [to_date, setto_date] = useState("");
  const [download_url, setdownload_url] = useState("");
  const [excelImport, setexcelImport] = useState("");
  const [excelImportErr, setexcelImportErr] = useState(false);

  const categories = [
    {
      name: "Booking",
    },
    {
      name: "Transaction",
    },
    {
      name: "Owner Payment",
    },
  ];

  // RTK QUERY
  const [bookingDetailsReportApi] = useLazyBookingDetailsReportQuery();
  const [ownerPaymentReportApi] = useLazyOwnerPaymentReportQuery();
  const [transactionReportApi] = useLazyTransactionReportQuery();
  const [ownerPaymentImportApi] = useOwnerPaymentImportMutation();

  const getBookingDetailsReport = (type) => {
    if (from_date && to_date) {
      let params = `/${moment(from_date).format("YYYY-MM-DD")}/${moment(
        to_date
      ).format("YYYY-MM-DD")}`;
      dispatch(saveLoader(true));
      setBtn(true);
      bookingDetailsReportApi(params)
        .unwrap()
        .then((res) => {
          if (type == 2) {
            if (res?.download_url) {
              const link = document.createElement("a");
              link.href = res?.download_url;
              link.setAttribute("download", "");
              link.setAttribute("target", "_blank");
              document.body.appendChild(link);
              link.click();
            }
          }
          if (res?.download_url) {
            setdownload_url(res?.download_url);
          }
          setbooking_details(res?.booking_details);
          dispatch(saveLoader(false));
          setBtn(false);
        })
        .catch((err) => {
          dispatch(saveLoader(false));
          setBtn(false);
          console.log("err", err);
        });
    } else {
      alert("Select From Date and To Date");
    }
  };

  const getownerPaymentReport = (type) => {
    if (from_date && to_date) {
      let params = `/${moment(from_date).format("YYYY-MM-DD")}/${moment(
        to_date
      ).format("YYYY-MM-DD")}`;
      dispatch(saveLoader(true));
      setBtn(true);
      ownerPaymentReportApi(params)
        .unwrap()
        .then((res) => {
          if (type == 2) {
            if (res?.download_url) {
              const link = document.createElement("a");
              link.href = res?.download_url;
              link.setAttribute("download", "");
              link.setAttribute("target", "_blank");
              document.body.appendChild(link);
              link.click();
            }
          }
          if (res?.download_url) {
            setdownload_url(res?.download_url);
          }
          setowner_details(res?.owner_payments);
          dispatch(saveLoader(false));
          setBtn(false);
        })
        .catch((err) => {
          dispatch(saveLoader(false));
          setBtn(false);
          console.log("err", err);
        });
    } else {
      alert("Select From Date and To Date");
    }
  };

  const gettransactionReport = (type) => {
    if (from_date && to_date) {
      let params = `/${moment(from_date).format("YYYY-MM-DD")}/${moment(
        to_date
      ).format("YYYY-MM-DD")}`;
      dispatch(saveLoader(true));
      setBtn(true);
      transactionReportApi(params)
        .unwrap()
        .then((res) => {
          if (type == 2) {
            if (res?.download_url) {
              const link = document.createElement("a");
              link.href = res?.download_url;
              link.setAttribute("download", "");
              link.setAttribute("target", "_blank");
              document.body.appendChild(link);
              link.click();
            }
          }
          if (res?.download_url) {
            setdownload_url(res?.download_url);
          }
          settransaction_details(res?.transaction_reports);
          dispatch(saveLoader(false));
          setBtn(false);
        })
        .catch((err) => {
          dispatch(saveLoader(false));
          setBtn(false);
          console.log("err", err);
        });
    } else {
      alert("Select From Date and To Date");
    }
  };

  const saveHandler = () => {
    if (excelImport?.length == 0) {
      setexcelImportErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("owner_payment_import", excelImport);
      dispatch(saveLoader(true));
      setBtn(true);

      ownerPaymentImportApi(formdata)
        .unwrap()
        .then((res) => {
          dispatch(saveLoader(false));
          setBtn(false);
          if (res?.status == "success") {
            Swal.fire({
              text: res?.message,
              icon: "success",
            });

            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        })
        .catch((err) => {
          console.log("err", err);
          dispatch(saveLoader(false));
          setBtn(false);
        });
    }
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"report-list"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="nav-user mb-4" style={{ overflow: "auto" }}>
            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 1 ? "pre-active" : ""
                }`}
                onClick={() => setTab(1)}
              >
                Export
              </button>
            </div>

            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 2 ? "pre-active" : ""
                }`}
                onClick={() => setTab(2)}
              >
                Import
              </button>
            </div>
          </div>
          <div>
            {tab == 1 && (
              <div>
                <div className="d-flex gap-3">
                  <div className="col-md-4 p-0">
                    <div className="w-90 d-flex flex-column">
                      <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                        Report Type
                      </label>
                      <select
                        className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                        onChange={(e) => {
                          setcategory(e.target.value);
                          setdownload_url("");
                          setfrom_date("");
                          setto_date("");
                        }}
                        value={category}
                      >
                        <option value={""}>Select</option>
                        {categories?.map((item, ind) => {
                          return (
                            <option value={item?.name} key={ind}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4  p-0">
                    <div className="w-90 d-flex flex-column">
                      <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                        From Date
                      </label>
                      <DatePicker
                        selected={from_date}
                        onChange={(date) => {
                          setfrom_date(date);
                        }}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="yyyy-MM-dd"
                        todayButton="Today"
                        className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                        placeholderText="YYYY-MM-DD"
                      />
                    </div>
                  </div>
                  <div className="col-md-4 p-0">
                    <div className="w-90 d-flex flex-column">
                      <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                        To Date
                      </label>
                      <DatePicker
                        selected={to_date}
                        onChange={(date) => setto_date(date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="yyyy-MM-dd"
                        todayButton="Today"
                        className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                        placeholderText="YYYY-MM-DD"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 text-center mx-3 mt-5 mb-5">
                  {category == "Booking" && (
                    <button
                      className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                      onClick={() => getBookingDetailsReport(1)}
                      disabled={btn}
                    >
                      Booking Report
                    </button>
                  )}
                  {category == "Transaction" && (
                    <button
                      className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                      onClick={() => getownerPaymentReport(1)}
                      disabled={btn}
                    >
                      Transaction Report
                    </button>
                  )}
                  {category == "Owner Payment" && (
                    <button
                      className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                      onClick={() => gettransactionReport(1)}
                      disabled={btn}
                    >
                      Property Owner Report
                    </button>
                  )}
                </div>

                {download_url && (
                  <div className="col-md-12 text-start mx-3 mt-5 mb-5">
                    {category == "Booking" && (
                      <button
                        className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                        onClick={() => getBookingDetailsReport(2)}
                        disabled={btn}
                      >
                        Export
                      </button>
                    )}
                    {category == "Transaction" && (
                      <button
                        className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                        onClick={() => getownerPaymentReport(2)}
                        disabled={btn}
                      >
                        Export
                      </button>
                    )}
                    {category == "Owner Payment" && (
                      <button
                        className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                        onClick={() => gettransactionReport(2)}
                        disabled={btn}
                      >
                        Export
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {tab == 2 && (
              <div>
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Import File
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      onChange={(e) => setexcelImport(e.target.files[0])}
                      type={"file"}
                    />
                  </div>
                  {excelImport?.length == 0 && excelImportErr && (
                    <p className="err">Add File</p>
                  )}
                </div>
                <div className="col-md-12 text-center mx-3 mt-5 mb-5">
                  {excelImport && (
                    <button
                      className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                      onClick={() => saveHandler()}
                      disabled={btn}
                    >
                      Upload
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportPage;
